import { useModal } from "@/features/modal/ModalStackManager";
import { EquipmentAutoComplete } from "@/features/ui/autoComplete/equipment/equipment-autoComplete";
import { ItemAutoComplete } from "@/features/ui/autoComplete/item/item-autoComplete";
import { Calendar, isCalendarDate } from "@/features/ui/calendar";
import timeUtil from "@/utils/timeUtil";
import { ActionIcon, Flex, Text } from "@mantine/core";
import { ItemsGet200ResponseRowsInnerItemTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";
import { IconCalendar } from "@tabler/icons-react";

interface KPIActionHeaderProps {
  stateDate: [Date | null, Date | null];
  setStateDate: React.Dispatch<React.SetStateAction<[Date | null, Date | null]>>;
  setItem?: React.Dispatch<React.SetStateAction<string | null>>;
  mode?: "equipment" | "item";
}

export const KPIActionHeader = (props: KPIActionHeaderProps) => {
  const { stateDate, setStateDate, setItem, mode = "none" } = props;
  const { openModal } = useModal();

  return (
    <Flex w="100%" justify="center" align="center" pos="relative">
      {/* 캘린더 중앙 */}
      <Flex
        gap="sm"
        align="center"
        onClick={() => {
          openModal(
            <Calendar dates={stateDate} type="range" isExclude={true} />,
            null,
            "날짜 선택",
          ).then((value) => {
            if (isCalendarDate(value)) {
              setStateDate(value);
            }
          });
        }}
        style={{ cursor: "pointer" }}
      >
        <Text size="2rem" fw="bold">
          {timeUtil(stateDate[0]?.toISOString() ?? "")} ~{" "}
          {timeUtil(stateDate[1]?.toISOString() ?? "")}
        </Text>
        <ActionIcon>
          <IconCalendar size="2rem" />
        </ActionIcon>
      </Flex>

      {mode !== "none" && (
        <Flex pos="absolute" right={0} top="50%" style={{ transform: "translateY(-50%)" }}>
          {mode === "equipment" ? (
            <EquipmentAutoComplete
              placeholder="설비를 선택해주세요"
              w="22rem"
              size="lg"
              onChange={setItem}
            />
          ) : mode === "item" ? (
            <ItemAutoComplete
              placeholder="품목을 선택해주세요"
              w="22rem"
              size="lg"
              getItemType={[
                ItemsGet200ResponseRowsInnerItemTypeEnum.PRODUCT,
                ItemsGet200ResponseRowsInnerItemTypeEnum.SEMI_PRODUCT,
              ]}
              onChange={setItem}
            />
          ) : null}
        </Flex>
      )}
    </Flex>
  );
};
